import Modal from "modal/Modal";
import FormValidator from "base/FormValidator";
import $ from "jquery";

class PageSettingsModal extends Modal {
    constructor(page, tab = null) {
        super({destroyOnClose: true, class: "admin-modal--navigation"});

        this.page = page;
        this.tabs = [];

        let $content = (
            eotwJSXFactory('form', {class: "admin-form"}, [
                eotwJSXFactory('div', {class: "admin-modal__navigation js-tabs"}),
                eotwJSXFactory('div', {class: "js-tab-content"}),
                eotwJSXFactory('div', {class: "admin-modal__buttons"}, [
                    eotwJSXFactory('button', {class: "admin-btn admin-btn--confirm admin-btn--modal", type: "submit"}, ["Ok"]),
                    eotwJSXFactory('button', {class: "admin-btn admin-btn--cancel admin-btn--modal js-cancel"}, ["Cancel"])
                ])
            ])
        );

        this.setContent($content);

        FormValidator.attach($content).on("submit", () => {
            $content.find("input, textarea, select").filter("[name]").each(function () {
                page.updateValue($(this).attr("name"), $(this).val());
            });
            this.emit("submit");
            this.hide();
        });
        const me = this;
        this.on("click", ".js-cancel", () => {
            this.emit("cancel");
            this.hide();
            return false;
        }).on("click", ".js-show-tab", function () {
            me.$content.find(".js-tabs button").removeClass("admin-modal__link--active");
            me.$content.find(".js-tab-content").children().hide();
            $(this).addClass("admin-modal__link--active").data("content").show();
            return false;
        });

        this.addTab("SEO Settings", (
            eotwJSXFactory('div', null, [
                eotwJSXFactory('h2', null, ["SEO Settings"]),
                eotwJSXFactory('p', null, ["The Meta Title and Meta Description are important for your search engine listings, so ensure they’re appropriate"]),
                eotwJSXFactory('div', {class: "admin-form__row"}, [
                    eotwJSXFactory('label', {class: "admin-form__label", for: "page-meta-title"}, ["Meta Title"]),
                    eotwJSXFactory('input', {type: "text", class: "js-title admin-form__input", id: "page-meta-title", name: "meta title", value: page.workingRevision.values['meta title'], 'data-optional': true})
                ]),
                eotwJSXFactory('div', {class: "admin-form__row"}, [
                    eotwJSXFactory('label', {class: "admin-form__label", for: "page-meta-description"}, ["Meta Description"]),
                    eotwJSXFactory('textarea', {class: "admin-form__input admin-form__input--textarea js-description", name: "meta description", id: "page-meta-description", 'data-optional': true}, [page.workingRevision.values['meta description']])
                ])
            ])
        ));

        this.on("show", () => {
            if (tab) {
                this.$content.find(".js-tabs .js-show-tab[data-name='" + tab + "']").click();
            } else {
                this.$content.find(".js-tabs .js-show-tab").first().click();
            }
        })
    }


    addTab(name, $content) {
        this.tabs.push(name, $content);

        this.$content.find(".js-tab-content").append($content.hide());
        this.$content.find(".js-tabs").append(eotwJSXFactory('button', {'data-name': name, class: "admin-modal__link js-show-tab", type: "button"}, [name]).data("content", $content))
    }
}

export default PageSettingsModal;
